import React, { Fragment } from "react";

import { Mobile, Tablet, Desktop } from "../../../../hocs/Responsive";
import { useIntlTranslate } from "../../../../hooks";
import { Table } from "../../../../components/table/Table";
import { useRoamingDevices } from "../../../spson/roamingTables/useRoamingDevices";
import {
  RoamingRowSubComponent,
  RoamingRowSubComponentMobile,
} from "../../../spson/roamingTables/RoamingRowSubComponent";
import {
  RoamingDevicesSubHeader,
  RoamingDevicesTableHeader,
} from "./components";
import {
  COLUMNS_DESKTOP,
  COLUMNS_TABLET,
  COLUMNS_MOBILE,
  INITIAL_SORT,
  SEARCH_KEYS,
} from "./RoamingDevicesTable.consts";

export const RoamingDevicesTable = () => {
  const data = useRoamingDevices();
  const translate = useIntlTranslate();
  const caption = translate("roaming_devices_table_description");

  return (
    <Fragment>
      <Mobile>
        <Table
          header={<RoamingDevicesTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          visibleHeader={false}
          data={data}
          columns={COLUMNS_MOBILE}
          defaultSorted={INITIAL_SORT}
          noDataMessageID={"no_devices_found"}
          hiddenColumns={["protectionStatus", "lastSeen"]}
          subHeader={<RoamingDevicesSubHeader />}
          renderRowSubComponent={RoamingRowSubComponentMobile}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </Mobile>
      <Tablet>
        <Table
          header={<RoamingDevicesTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          columns={COLUMNS_TABLET}
          data={data}
          defaultSorted={INITIAL_SORT}
          subHeader={<RoamingDevicesSubHeader />}
          renderRowSubComponent={RoamingRowSubComponent}
          noDataMessageID={"no_devices_found"}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </Tablet>
      <Desktop>
        <Table
          header={<RoamingDevicesTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          columns={COLUMNS_DESKTOP}
          data={data}
          defaultSorted={INITIAL_SORT}
          subHeader={<RoamingDevicesSubHeader />}
          renderRowSubComponent={RoamingRowSubComponent}
          noDataMessageID={"no_devices_found"}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </Desktop>
    </Fragment>
  );
};
